import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.scss';
import 'antd/dist/antd.css';
import ru from 'dayjs/locale/ru';
import { Provider } from 'react-redux';
import dayjs from 'dayjs';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import moment from 'moment';
import 'moment/locale/ru';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './store/store';

dayjs.locale(ru);
moment.locale('ru');

Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN_URL,
    integrations: [new BrowserTracing()],
    tracesSampleRate: 1.0,
});

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
